export const brandColors = {
  Default: "#3b82f6", // Premium Blue
  Toyota: "#ef4444", // Vibrant Red
  Honda: "#38bdf8", // Light Sky Blue
  Ford: "#2563eb", // Royal Blue
  Chevrolet: "#f59e0b", // Amber/Gold
  Nissan: "#e11d48", // Rose Red
  Bmw: "#0ea5e9", // Cerulean Blue
  Mercedesbenz: "#cbd5e1", // Platinum Silver
  Audi: "#be123c", // Crimson
  Volkswagen: "#0284c7", // Ocean Blue
  Hyundai: "#1d4ed8", // Deep Blue
  Kia: "#f43f5e", // Electric Rose
  Tesla: "#dc2626", // Racing Red
  Lexus: "#94a3b8", // Slate Silver
  Porsche: "#d97706", // Rich Gold
  Ferrari: "#eab308", // Bright Yellow
  Lamborghini: "#facc15", // Neon Yellow
  Maserati: "#3b82f6", // Azure Blue
  Jeep: "#65a30d", // Olive Green
  Subaru: "#0284c7", // Star Blue
  Landrover: "#10b981", // Emerald Green
};